import { Button } from '@components/Button';
import { IconButton } from '@components/IconButton';
import { IconInfo } from '@components/icons';
import { Tooltip } from '@components/Tooltip';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

export const TooltipSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Tooltip"
      description="A lightweight tooltip that appears on hover with minimal delay. Replaces native title attributes for faster, styled feedback."
      styles={styles}
    />

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Position</h3>
      <div className={styles.infoChipRow}>
        <Tooltip text="Appears above (default)" position="top">
          <Button variant="secondary" size="small">Top</Button>
        </Tooltip>
        <Tooltip text="Appears below" position="bottom">
          <Button variant="secondary" size="small">Bottom</Button>
        </Tooltip>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>With Icon Button</h3>
      <div className={styles.infoChipRow}>
        <Tooltip text="More information">
          <IconButton size="medium" aria-label="Info">
            <IconInfo size={18} />
          </IconButton>
        </Tooltip>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Long Text</h3>
      <div className={styles.infoChipRow}>
        <Tooltip text="This is a longer tooltip message that wraps to multiple lines when needed">
          <Button variant="secondary" size="small">Hover for details</Button>
        </Tooltip>
      </div>
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>No Text (renders children only)</h3>
      <div className={styles.infoChipRow}>
        <Tooltip text="">
          <Button variant="secondary" size="small">No tooltip</Button>
        </Tooltip>
      </div>
    </div>
  </section>
);
